import React, { FC } from "react"
import { Icon } from "@zambezi/sdk/icons"
import { WrappedIconProps } from "./WrappedIcon.types"

import "./WrappedIcon.scss"

const IconWrapper: FC<WrappedIconProps> = ({
    rounded,
    border,
    className,
    ...props
}: WrappedIconProps) => {
    let klass = `zb-icon-wrapper ${className ?? ""}`
    if (border) klass += " zb-has-border"

    if (rounded) klass += " zb-is-rounded"

    return (
        <i className={klass}>
            <Icon title="" {...props} />
        </i>
    )
}

export default IconWrapper
